export default "__VITE_ASSET__CMnEg2D2__"